(function ($, unknown, intercomAppId, accountDetails) {

    'use strict';

    $(function () {

        const timePeriods = RivalIQ.state.timePeriods;

        RivalIQ.apps.Shell.execute('show:app', {
            options: {
                unknown: unknown,
                intercomAppId: intercomAppId,
                accountDetails: accountDetails
            },
            page: RivalIQ.configuration.menus.getConfiguration().ADMIN,
            app: RivalIQ.apps.Admin.apps.Account,
            components: {
                companySets: {
                    disabled: true
                },
                timePeriod: timePeriods.getDefinitionByType(timePeriods.types.NOT_AVAILABLE)
            }
        });

    });

}(window.jQuery, window.unknown, window.intercomAppId, window.accountDetails));
